

<div class="container mt-5">
    <div class="card card-primary">
      <div *ngIf="loader==true">
        <app-loader style="text-align: center;"></app-loader>
      </div>
      <!-- /.card-header -->
      <!-- form start -->
      <form id="quickForm" [formGroup]="eventForm" (ngSubmit)="onSubmit()">
        <div class="card-body">
          <div class="form-group">
            <app-form-field label="{{ 'SKU' }}" [required]="true" [control]="eventForm.controls['SKU']"
              [isInline]="false">
              <app-input formControlName="SKU"></app-input>
            </app-form-field>
          </div>
          <div class="form-group">
            <app-form-field label="{{ 'Product Name' }}" [required]="true" [control]="eventForm.controls['ProductName']"
              [isInline]="false">
              <app-input formControlName="ProductName"></app-input>
            </app-form-field>
          </div>
          <div class="form-group">
            <app-form-field label="{{ 'Description' }}" [required]="true" [control]="eventForm.controls['Description']"
              [isInline]="false">
              <app-input formControlName="Description"></app-input>
            </app-form-field>
          </div>
          <div class="form-group">
            <app-form-field label="{{ 'Distributor Price' }}" [required]="true" [control]="eventForm.controls['DistributorPrice']"
              [isInline]="false">
              <app-input formControlName="DistributorPrice"></app-input>
            </app-form-field>
          </div>
  
          <div class="form-group">
            <app-form-field label="{{ 'Retail Price' }}" [required]="true" [control]="eventForm.controls['RetailPrice']"
              [isInline]="false">
              <app-input formControlName="RetailPrice"></app-input>
            </app-form-field>
          </div>
  
          <div class="form-group">
            <app-form-field label="{{ 'Unit' }}" [required]="true" [control]="eventForm.controls['Unit']"
              [isInline]="false">
              <app-input formControlName="Unit"></app-input>
            </app-form-field>
          </div>
  
          <!-- <div class="form-group">
            <app-form-field label="{{ 'Unit' }}" [required]="true" [control]="eventForm.controls['Unit']"
              [isInline]="false">
              <app-input formControlName="Unit"></app-input>
            </app-form-field>
          </div> -->
  
          <div class="form-group">
          
            <app-form-field label="{{ 'CategoryId' }}" [required]="true" [control]="eventForm.controls['CategoryId']"
            [isInline]="false">
            <app-select [items]="categoryData" formControlName="CategoryId"></app-select>
          </app-form-field>
          </div>
  
          <div class="form-group">
            <app-form-field label="{{ 'Total Stock' }}" [required]="true" [control]="eventForm.controls['TotalStock']"
              [isInline]="false">
              <app-input formControlName="TotalStock"></app-input>
            </app-form-field>
          </div>

          <div class="row">
            <div class="col-lg-5">
              <app-form-field label="{{ 'image' }} JPEG/PNG" [required]="false" [isInline]="false">
                <input id="file" class="form-control form-control-lg" type="file" (change)="setUserOrPassportImage($event)" />
              </app-form-field>
            </div>
          </div>
          
  
          <!-- <div class="form-group">
            <app-form-field label="{{ 'Stock Sold' }}" [required]="true" [control]="eventForm.controls['StockSold']"
              [isInline]="false">
              <app-input formControlName="StockSold"></app-input>
            </app-form-field>
          </div>
  
          <div class="form-group">
            <app-form-field label="{{ 'Stock Remaining' }}" [required]="true" [control]="eventForm.controls['StockRemaining']"
              [isInline]="false">
              <app-input formControlName="StockRemaining"></app-input>
            </app-form-field>
          </div> -->
  
          <div class="form-group">
            <app-form-field label="{{ 'Product Type' }}" [required]="true" [control]="eventForm.controls['ProductType']"
                  [isInline]="false">
                  <app-select [items]="productType" formControlName="ProductType"></app-select>
                 
                </app-form-field>
          </div>
        </div>
        <!-- /.card-body -->
        <div class="card-footer">
          <button type="button" class="btn btn-primary" (click)="onSubmit()">Submit</button> &nbsp;&nbsp;
          <button type="button" class="btn btn-outline-dark" (click)="activeModal.dismiss({ refresh: false })">
            Close
          </button>
        </div>
      </form>
    </div>
  
  
  </div>